/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { VideoObject } from '@/types/seoSchema';

type VideoSchemaOptions = {
  name: string;
  description?: string;
  thumbnailUrl?: string;
  uploadDate?: string;
  contentUrl?: string;
  embedUrl?: string;
};

export const getVideoSchema = ({
  name,
  description,
  thumbnailUrl,
  uploadDate,
  contentUrl,
  embedUrl,
}: VideoSchemaOptions): VideoObject => {
  return {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name,
    ...(description && { description }),
    ...(thumbnailUrl && { thumbnailUrl }),
    ...(uploadDate && { uploadDate }),
    ...(contentUrl && { contentUrl }),
    ...(embedUrl && { embedUrl }),
  };
};
